import React from "react";
import GenericErrorPage from "./GenericErrorPage";

export default () => (
  <GenericErrorPage
    src="https://http.cat/500"
    alt="Error"
    heading="Whoops!"
    description="Looks like you found a bug in out website. Our developers have been notified and are working hard to fix it."
  />
);
